import { render, staticRenderFns } from "./plus-24.vue?vue&type=template&id=f2c42f4e&scoped=true"
import script from "./plus-24.vue?vue&type=script&lang=js"
export * from "./plus-24.vue?vue&type=script&lang=js"
import style0 from "./plus-24.vue?vue&type=style&index=0&id=f2c42f4e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c42f4e",
  null
  
)

export default component.exports